//dbController.js
export const DB_NAME = "OfflinePOSDB";
export const DB_VERSION = 3;
export const PRODUCT_STORE = "products";
export const SALES_STORE = "sales";
//Users will have changed pin field, default false then true when changed
export const USERS_STORE = "users";
export const OTHERPRODUCT_STORE = "otherproducts";
//Each sale will have sale key values, then saleitems & salepayments objects 
export const RATE_STORE = "rates";
export const TRANSFER_STORE = "transfers";
export const EXPENSE_STORE = "expenses";


export function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(PRODUCT_STORE)) {
        db.createObjectStore(PRODUCT_STORE, { keyPath: "id", autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(SALES_STORE)) {
        db.createObjectStore(SALES_STORE, { keyPath: "id", autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(USERS_STORE)) {
        db.createObjectStore(USERS_STORE, { keyPath: "id", autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(OTHERPRODUCT_STORE)) {
        db.createObjectStore(OTHERPRODUCT_STORE, { keyPath: "id", autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(RATE_STORE)) {
        db.createObjectStore(RATE_STORE, { keyPath: "id", autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(TRANSFER_STORE)) {
        db.createObjectStore(TRANSFER_STORE, { keyPath: "id", autoIncrement: true });
      }
      if (!db.objectStoreNames.contains(EXPENSE_STORE)) {
        db.createObjectStore(EXPENSE_STORE, { keyPath: "id", autoIncrement: true });
      }
    };

    request.onsuccess = (event) => resolve(event.target.result);
    request.onerror = (event) => reject(event.target.error);
  });
}

export async function fetchProductsFromServer() {
  try {
    const response = await fetch("https://your-server.com/api/products");
    if (!response.ok) throw new Error("Network response was not ok");
    const products = await response.json();
    return products; // Array of product objects
  } catch (error) {
    console.error("Failed to fetch products:", error);
    return [];
  }
}

export async function updateProductsFromServer() {
  const newProducts = await fetchProductsFromServer();
  if (!newProducts.length) return;

  // Delete old products
  await clearObjectStore(PRODUCT_STORE);

  // Add new products
  for (const product of newProducts) {
    await addRecord(PRODUCT_STORE, product);
  }

  // Optionally reload products in state
  //fetchProducts();
}

export function addRecord(storeName, record) {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, "readwrite");
      const store = tx.objectStore(storeName);
      store.add(record);
      tx.oncomplete = () => resolve();
      tx.onerror = (e) => reject(e);
    });
  });
}

export async function updateRecord(storeName, record) {
  const db = await openDB();

  if (!db.objectStoreNames.contains(storeName)) {
    throw new Error(`Store ${storeName} not found`);
  }

  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, "readwrite");
    const store = tx.objectStore(storeName);

    const getRequest = store.get(record.id);

    getRequest.onsuccess = () => {
      const existing = getRequest.result || {};

      // ✅ Merge old record with new fields
      const updated = { ...existing, ...record };

      const updateRequest = store.put(updated);

      updateRequest.onsuccess = () => resolve(updated);
      updateRequest.onerror = (e) => reject(e);
    };

    getRequest.onerror = (e) => reject(e);
  });
}


export function getAllRecords(storeName) {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, "readonly");
      const store = tx.objectStore(storeName);
      const request = store.getAll();
      request.onsuccess = () => resolve(request.result);
      request.onerror = (e) => reject(e);
    });
  });
}

export async function markRecordsAsSynced(storeName, sentId) {
  const db = await openDB();

  if (!db.objectStoreNames.contains(storeName)) {
    throw new Error(`Store ${storeName} not found`);
  }

  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, "readwrite");
    const store = tx.objectStore(storeName);

    // Get all records first
    const getAllReq = store.getAll();

    getAllReq.onsuccess = () => {
      const records = getAllReq.result || [];

      // Filter records to update
      const toUpdate = records.filter((r) => r.id <= sentId);

      toUpdate.forEach((record) => {
        record.synced = 1;
        store.put(record); // update the record
      });

      tx.oncomplete = () => {
        console.log(`✅ Updated ${toUpdate.length} records in ${storeName}`);
        resolve(toUpdate.length);
      };

      tx.onerror = (e) => reject(e);
    };

    getAllReq.onerror = (e) => reject(e);
  });
}


export async function clearAllRecords(storeName) {
  const db = await openDB(); // wait for DB to open

  if (!db.objectStoreNames.contains(storeName)) {
    throw new Error(`❌ Store "${storeName}" not found`);
  }

  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, "readwrite");
    const store = tx.objectStore(storeName);

    const request = store.clear();

    request.onsuccess = () => {
      console.log(`✅ All records cleared from ${storeName}`);
      resolve();
    };

    request.onerror = (e) => {
      console.error(`❌ Failed to clear ${storeName}:`, e);
      reject(e);
    };
  });
}


function requestToPromise(request) {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function loginUser(email, password) {
  const db = await openDB();
  const tx = db.transaction(USERS_STORE, "readonly");
  const store = tx.objectStore(USERS_STORE);

  const users = await requestToPromise(store.getAll());
  const user = users.find(
    (u) => u.email === email && u.password === password
  );

  if (!user) throw new Error("❌ Login failed — invalid email or password");
  return user;
}

export function clearObjectStore(storeName) {
  return openDB().then((db) => {
    return new Promise((resolve, reject) => {
      const tx = db.transaction(storeName, "readwrite");
      const store = tx.objectStore(storeName);
      store.clear();
      tx.oncomplete = () => resolve();
      tx.onerror = (e) => reject(e);
    });
  });
}

export async function getLastSalesId() {
  const db = await openDB();
  const tx = db.transaction(SALES_STORE, "readonly");
  const store = tx.objectStore(SALES_STORE);

  return new Promise((resolve, reject) => {
    const request = store.openCursor(null, "prev"); // reverse order

    request.onsuccess = (event) => {
      const cursor = event.target.result;
      if (cursor) {
        resolve(cursor.value.id); // first record in reverse order is the last inserted
      } else {
        resolve(0); // no records yet
      }
    };

    request.onerror = (e) => reject(e.target.error);
  });
}

